module.exports = __webpack_public_path__ + "media/images/icon/lession-18a0821e5ab47ec8ebd9bfb175991cb1.svg";